export const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24

export const getDiffInDays = (dateA: Date, dateB: Date) =>
  Math.round((dateA.getTime() - dateB.getTime()) / MILLISECONDS_PER_DAY)
